/**
 * Pass currency: online club (YooKassa) = RUB; studio / rest = ILS.
 */
export function passCurrencySymbol(currency) {
  if (currency === 'RUB') return '₽';
  return '₪';
}

export function formatPassPrice(finalPrice, currency) {
  if (finalPrice == null || finalPrice === '') return null;
  const sym = passCurrencySymbol(currency);
  const cur = currency === 'RUB' ? 'RUB' : 'ILS';
  return `${finalPrice} ${sym} (${cur})`;
}

export function formatPassPriceShort(finalPrice, currency) {
  if (finalPrice == null || finalPrice === '') return '—';
  return `${finalPrice} ${passCurrencySymbol(currency)}`;
}

export function finalPriceLabel(currency) {
  const cur = currency === 'RUB' ? 'RUB' : 'ILS';
  const sym = passCurrencySymbol(currency);
  return `Final price (${sym} ${cur})`;
}
